import { cn } from "@utils/tw"
import { ComponentProps } from "react"

export function Spinner(props: ComponentProps<"span">) {
  return (
    <span
      {...props}
      className={cn(
        "inline-flex relative w-[1em] h-[1em]",
        "before:content-[''] before:absolute before:inset-0 before:border before:border-transparent before:border-t-current before:rounded-full before:animate-[spin_0.7s_linear_infinite]",
        "after:content-[''] after:absolute after:inset-0 after:border after:border-current after:opacity-10 after:rounded-full",
        props.className,
      )}
    />
  )
}
